// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountsByCaseSearchRequestModel {
    static getAttributeTypeMap() {
        return AccountsByCaseSearchRequestModel.attributeTypeMap;
    }
}
AccountsByCaseSearchRequestModel.discriminator = undefined;
AccountsByCaseSearchRequestModel.additionalProperties = false;
AccountsByCaseSearchRequestModel.attributeTypeMap = [
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "number"
    },
    {
        "name": "statusId",
        "baseName": "statusId",
        "type": "number"
    },
    {
        "name": "subStatusId",
        "baseName": "subStatusId",
        "type": "number"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "string"
    },
    {
        "name": "subStatus",
        "baseName": "subStatus",
        "type": "string"
    },
    {
        "name": "createdBefore",
        "baseName": "createdBefore",
        "type": "Date"
    },
    {
        "name": "createdAfter",
        "baseName": "createdAfter",
        "type": "Date"
    },
    {
        "name": "endBefore",
        "baseName": "endBefore",
        "type": "Date"
    },
    {
        "name": "endAfter",
        "baseName": "endAfter",
        "type": "Date"
    },
    {
        "name": "isAssigned",
        "baseName": "isAssigned",
        "type": "boolean"
    },
    {
        "name": "assignedUserId",
        "baseName": "assignedUserId",
        "type": "number"
    },
    {
        "name": "caseExternalId",
        "baseName": "caseExternalId",
        "type": "string"
    },
    {
        "name": "caseExternalIdType",
        "baseName": "caseExternalIdType",
        "type": "CaseExternalIdType"
    },
    {
        "name": "externalTypeCategoryId",
        "baseName": "externalTypeCategoryId",
        "type": "number"
    },
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
];
//# sourceMappingURL=accountsByCaseSearchRequestModel.js.map